import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Dropzone from 'react-dropzone';

class DropzoneFileUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            previews: [],
            error: false
        };
    }

    static propTypes = {
        onUpload: PropTypes.func,
        className: PropTypes.string,
        showPreview: PropTypes.bool,
        accept: PropTypes.string,
        text: PropTypes.string,
        dropzoneClass: PropTypes.string,
        image: PropTypes.object,
        disabled: PropTypes.bool,
        readAsText: PropTypes.bool,
        maxFiles: PropTypes.number
    };

    handleChange = ([newFile]) => {
        const { readAsText = false } = this.props;
        const newPreviews = [];
        newPreviews.push({
            name: newFile.name,
            preview: newFile.preview
        });
        const reader = new FileReader();
        if (readAsText) {
            reader.readAsText(newFile);
        } else {
            reader.readAsArrayBuffer(newFile);
        }
        reader.onloadend = () => {
            const file = reader.result;
            const param = {
                file,
                name: newFile.name,
                size: newFile.size,
                type: newFile.type
            };
            return this.props
                .onUpload(param)
                .then(() => {
                    this.setState((prevstate) => {
                        if (prevstate.previews) {
                            return { previews: [...newPreviews, ...prevstate.previews] };
                        }
                        return { previews: newPreviews };
                    });
                })
                .catch((err) => {
                    console.log(err);
                    this.setState(() => ({
                        previews: [],
                        error: true
                    }));
                });
        };
    };

    render() {
        const {
            className = 'col-sm-12',
            dropzoneClass,
            text = 'Drop or upload a file',
            accept = 'image/*, application/vnd.ms-powerpoint, application/pdf, application/vnd.ms-excel, application/msword, text/plain, video/mp4, video/x-m4v, video/*, audio/mp3, audio/*',
            showPreview = false,
            image,
            disabled = false,
            maxFiles = 0
        } = this.props;
        const { previews, error } = this.state;

        return (
            <div className={className}>
                <Dropzone
                    multiple={false}
                    className={cns('dropzone-upload', dropzoneClass)}
                    onDrop={this.handleChange}
                    accept={accept}
                    disabled={disabled}
                    maxFiles={maxFiles}
                >
                    {image || null}
                    <p className={cns('dropzone-paragraph', { error })}>
                        {error ? 'There seems to have been an issue uploading your files' : text}
                    </p>
                </Dropzone>
                {showPreview ? (
                    <div className={'col-sm-12'}>
                        {previews.map((prev) => (
                            <img key={prev.name} src={prev.preview} className={'col-sm-4'} />
                        ))}
                    </div>
                ) : null}
            </div>
        );
    }
}

export default DropzoneFileUpload;
